// @ts-nocheck
import { FC } from 'react';
import Modal from 'react-modal-resizable-draggable';

interface IEditModal {
	state?: boolean;
	outsideClick?: () => void;
	children?: React.ReactNode;
	id?: number;
}

const ResizeModal: FC<IEditModal> = ({ state, outsideClick, children }) => {
	return (
		<div onClick={(event: React.MouseEvent) => event.stopPropagation()}>
			<Modal
				initWidth={800}
				minWidth={400}
				initHeight={450}
				minHeight={300}
				isOpen={state}
				onRequestClose={outsideClick}
				onFocus={() => { }}
			>
				{children}
			</Modal>
		</div>
	);
};

export default ResizeModal;
